module.exports = __webpack_public_path__ + "img/ico-close.e4120bf8.svg";